<template>
  <label
    v-if="item.externally_managed"
    :class="$style.externallyManagedLabel"
  >
    AD Integration:
    <div :class="$style.iconContainer">
      <i class="jc-directories-badge-bg" />
      <i :class="['jc-directories-badge-active-directory-fg', $style.foregroundIcon]" />
    </div>
  </label>
</template>

<script>
export default {
  name: 'AdBridgeLabel',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped module>
@value (lightBlue, infoBlue) from '~css/colors.css';

.externallyManagedLabel {
  color: lightBlue;
  display: block;
  font-size: 11px;
  font-weight: bold;
  margin: 2px 0 0;
  vertical-align: top;
}

.iconContainer {
  display: inline-block;
  height: 16px;
  margin-right: 2px;
  position: relative;
  vertical-align: middle;
  width: 16px;
}

.iconContainer i {
  font-size: 16px;
  left: 0;
  position: absolute;
  top: 0;
  vertical-align: middle;
}

.foregroundIcon {
  color: infoBlue;
}
</style>
